import FetchHelpers from "utils/FetchHelpers";

export default {
  getSearchLinks() {
    return FetchHelpers.get("/v1/contentful/menu");
  },
};
